import { render, staticRenderFns } from "./IntentoButton.vue?vue&type=template&id=49376fa0"
import script from "./IntentoButton.vue?vue&type=script&lang=js"
export * from "./IntentoButton.vue?vue&type=script&lang=js"
import style0 from "./IntentoButton.vue?vue&type=style&index=0&id=49376fa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports